/* eslint-disable max-len */

export default {
  blocks: [
    {
      key: 'foo',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {
        dynamicStyles: {
          'padding-top': '0px',
          'padding-bottom': '0px',
        },
        textAlignment: 'justify',
      },
    },
    {
      key: 's53',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 0,
        },
      ],
      data: {},
    },
    {
      key: 'e3sob',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2ui77',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 1,
        },
      ],
      data: {},
    },
    {
      key: 'ev5ni',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dm5qe',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 2,
        },
      ],
      data: {},
    },
    {
      key: 'akn59',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9qfd3',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 3,
        },
      ],
      data: {},
    },
    {
      key: 'f5rqu',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-divider',
      mutability: 'IMMUTABLE',
      data: {
        type: 'double',
        config: {
          size: 'medium',
          alignment: 'center',
          textWrap: 'nowrap',
        },
      },
    },
    '1': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'small',
          showTitle: true,
          showDescription: true,
        },
        src: {
          id: 'bbafa01c54087e7003f10c2c2a06a524',
          original_file_name: '8bb438_8d139a5df3aa4f709c66b8cdd28ac307.jpg',
          file_name: '8bb438_8d139a5df3aa4f709c66b8cdd28ac307.jpg',
          width: 5120,
          height: 3413,
        },
      },
    },
    '2': {
      type: 'wix-draft-plugin-vertical-embed',
      mutability: 'IMMUTABLE',
      data: {
        type: 'product',
        selectedProduct: {
          id: '265beaf5-3008-c5c2-fa5e-1447e0bebf71',
          name: 'flowers',
          pageUrl:
            'https://www.wix.app/stores/54e7b326-49ec-434f-a7cc-c2ad1eaec049/catalog/265beaf5-3008-c5c2-fa5e-1447e0bebf71?d=https://sapirs0.wixsite.com/mysite/product-page/flowers',
          imageSrc:
            'https://static.wixstatic.com/media/11062b_3a93dbce5ab64e7c90d9b2a83a598893~mv2.jpg/v1/fit/w_6720,h_4480,q_90/file.jpg',
        },
      },
    },
    '3': {
      type: 'wix-draft-plugin-poll',
      mutability: 'IMMUTABLE',
      data: {
        poll: {
          id: 'f3fa62b4-6d75-4016-a895-acb793ca6f5c',
          title: 'Where do you want to have breakfast tomorrow to use the monthly budget?',
          mediaId: 'https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg',
          createdBy: '3efa7e86-fc25-4ef1-a002-19769b84202f',
          count: 13,
          anonymousCount: 0,
          ownVotes: [
            '067ed3b5-f19d-4886-8f23-acd84a586522',
            'ee32a57f-bf6c-425a-a20c-e678bcf4a73b',
          ],
          settings: {
            multipleVotes: true,
            voteRole: 'SITE_MEMBERS',
            resultsVisibility: 'VOTERS_ONLY',
            votersDisplay: true,
            votesDisplay: true,
          },
          options: [
            {
              id: '067ed3b5-f19d-4886-8f23-acd84a586522',
              title: 'Cafe Nordoy',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_f12aec64c02f464c9d3f0f6d62ec7384~mv2.png',
              count: 5,
              anonymousCount: 0,
              rating: 38,
              latestVoters: [
                '84856a9a-f25f-4d8f-a774-56e0b8927bbe',
                '15c6f37e-c980-46ba-b450-11415ca5b4fe',
                '2bff5b99-e56c-421d-b5ec-cd432a5b6961',
                '3efa7e86-fc25-4ef1-a002-19769b84202f',
                '28ba5b75-0c82-4239-86e3-131879cb96e7',
              ],
            },
            {
              id: 'ee32a57f-bf6c-425a-a20c-e678bcf4a73b',
              title: 'קפה רוטשילד 65',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_c6ebbeecf9b4494f91244656beee6e78~mv2.jpg',
              count: 4,
              anonymousCount: 0,
              rating: 31,
              latestVoters: [
                '3efa7e86-fc25-4ef1-a002-19769b84202f',
                'dd0d2b42-ba5f-47e9-8a53-26c61c08f9ec',
                '3f3fa379-9a5a-4306-8a95-f79915ef479d',
                '7b3cad1d-bce1-4529-b402-d1e1e74962f1',
              ],
            },
            {
              id: '41679bf9-89ba-41f2-81d3-832d567531da',
              title: 'האחים',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_26d7f9c215944dbcb783c6b16f536c33~mv2.jpg',
              count: 3,
              anonymousCount: 0,
              rating: 23,
              latestVoters: [
                '15c6f37e-c980-46ba-b450-11415ca5b4fe',
                '13633644-d00c-4456-a189-1575ea044f10',
                '7b3cad1d-bce1-4529-b402-d1e1e74962f1',
              ],
            },
            {
              id: '378c6042-55cc-4e4a-9f0c-77824bee4964',
              title: 'הוטל מונטיפיורי',
              mediaId:
                'https://static.wixstatic.com/media/3efa7e_d9b16be508ce41aa8e635d0e9e97b923~mv2.jpeg',
              count: 1,
              anonymousCount: 0,
              rating: 8,
              latestVoters: ['dd0d2b42-ba5f-47e9-8a53-26c61c08f9ec'],
            },
          ],
          creatorFlag: true,
        },
        layout: {
          poll: {
            type: 'grid',
            direction: 'ltr',
            enableImage: false,
          },
          option: {
            enableImage: true,
          },
        },
        design: {
          poll: {
            backgroundType: 'image',
            background:
              'https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg',
            borderRadius: 0,
          },
          option: {
            borderRadius: 0,
          },
        },
        siteToken:
          'VBLuQllkHnrmBH_7O0-Xmzek4kW6U1qHy5-p36Rfkys.eyJpbnN0YW5jZUlkIjoiYTE2NDRiZmUtNzFmOC00MDFiLWI3YWEtNTgwYzkxMDBmMDk3IiwiYXBwRGVmSWQiOiIxNDhjMjI4Ny1jNjY5LWQ4NDktZDE1My00NjNjNzQ4NmE2OTQiLCJtZXRhU2l0ZUlkIjoiMzlkNjk1MTYtYWYwNC00ZTQ1LWE2NjAtMzQwNjIwZWQ0NGNkIiwic2lnbkRhdGUiOiIyMDIwLTA3LTMwVDA4OjQyOjQ2LjQ2MVoiLCJ1aWQiOiIzZWZhN2U4Ni1mYzI1LTRlZjEtYTAwMi0xOTc2OWI4NDIwMmYiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiZGVtb01vZGUiOmZhbHNlLCJhaWQiOiIzYTk1MzMzMS1hZGU4LTQzMDMtOWM5NC04NmIzNmU0ZDAzMzIiLCJiaVRva2VuIjoiOThiMmRlZTgtZGVmYy0wZTVlLTExY2EtNmMwYWIxZWRiNDVhIiwic2l0ZU93bmVySWQiOiIzZWZhN2U4Ni1mYzI1LTRlZjEtYTAwMi0xOTc2OWI4NDIwMmYiLCJleHBpcmF0aW9uRGF0ZSI6IjIwMjAtMDctMzBUMTI6NDI6NDYuNDYxWiIsImhhc1VzZXJSb2xlIjp0cnVlfQ',
        config: {
          alignment: 'center',
          size: 'large',
          width: 'full-width',
        },
      },
    },
  },
  VERSION: '8.49.7',
};
